import { IGirlItem } from "../components/GirlItem/GirlItem";
import { IResponseGetUsers } from "../types/user";

export const transformUsersToGirlItems = (
  users: IResponseGetUsers[],
): IGirlItem[] => {
  return users.map((user) => ({
    id: user.id,
    age: user.age ?? undefined,
    bust: user.breast ?? undefined,
    weight: user.weight ? user.weight.toString() : undefined,
    height: user.height ? user.height.toString() : undefined,
    name: user.firstName,
    zipIndex: user.zipIndex ?? null,
    city: user.city ?? null, // Ensure city is provided
    services: user.services ?? [], // Ensure services is provided
    photoSrc: user.avatarUrl ?? "",
    phone: user.phone ?? undefined,
    whatsapp: user.phone ? `https://wa.me/${user.phone}` : undefined,
    email: undefined, // Assuming no data for email in IResponseGetUsers
  }));
};
